import { Carousel, Col, Image, Layout, Row } from "antd";
import { motion } from "framer-motion";
import React from "react";
import "./Style.css";

import IMG1 from "../../assets/ai/1.svg";
import IMG10 from "../../assets/ai/10.svg";
import IMG11 from "../../assets/ai/11.svg";
import IMG12 from "../../assets/ai/12.svg";
import IMG13 from "../../assets/ai/13.svg";
import IMG14 from "../../assets/ai/14.svg";
import IMG15 from "../../assets/ai/15.svg";
import IMG16 from "../../assets/ai/16.svg";
import IMG17 from "../../assets/ai/17.svg";
import IMG18 from "../../assets/ai/18.svg";
import IMG19 from "../../assets/ai/19.svg";
import IMG2 from "../../assets/ai/2.svg";
import IMG20 from "../../assets/ai/20.svg";
import IMG21 from "../../assets/ai/21.svg";
import IMG23 from "../../assets/ai/23.svg";
import IMG24 from "../../assets/ai/24.svg";
import IMG25 from "../../assets/ai/25.svg";
import IMG3 from "../../assets/ai/3.svg";
import IMG4 from "../../assets/ai/4.svg";
import IMG5 from "../../assets/ai/5.svg";
import IMG6 from "../../assets/ai/6.svg";
import IMG7 from "../../assets/ai/7.svg";
import IMG8 from "../../assets/ai/8.svg";
import IMG9 from "../../assets/ai/9.svg";

const itemsSlide = [
  { id: 1, content: IMG3 },
  { id: 2, content: IMG4 },
  { id: 3, content: IMG5 },
  { id: 4, content: IMG6 },
  { id: 5, content: IMG7 },
  { id: 6, content: IMG8 },
];

const { Content } = Layout;
const AIPage = () => {
  return (
    <Layout>
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Image
          className="image-cover"
          src={IMG1}
          alt="Image 1"
          preview={false}
        />
      </div>
      <Content
        style={{
          padding: "40px 20px",
          maxWidth: "1400px",
          width: "100%",
          margin: "0 auto",
          overflow: "hidden",
        }}
      >
        <Row gutter={[30, 30]} align="middle">
          <Col
            xs={24}
            sm={24}
            md={12}
            className="d-flex justify-content-center"
          >
            <Image src={IMG2} alt="Image 2" preview={false} />
          </Col>
          <Col xs={24} sm={24} md={12}>
            <div className="text-section">My journey in Agriculture</div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <p
                className="text-color-2"
                style={{
                  display: "block",
                  marginBottom: "16px",
                  fontSize: "16px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Because of my passion for both agriculture and technology, I
                have always sought out opportunities to explore and develop my
                technical skills in hardware and software from a young age,
                while simultaneously nurturing my knowledge of agriculture. This
                drive has led me to participate in various robotics competitions
                and technical challenges, where I tested and expanded my
                abilities. Some of my most cherished memories come from these
                experiences - standing proudly with my team, clutching awards
                that represent not just victories but countless hours of
                dedication and learning.
              </p>
            </motion.div>
          </Col>
        </Row>
        <br />
        <br />
        <motion.div
          className="ai-1"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Image src={IMG9} alt="Image 9" preview={false} />
          <Row gutter={[30, 30]} align="middle" className="m-x-0">
            <div className="ai-sub-title">
              From farm to table or from table to farm?
            </div>
            <div className="ai-content">
              Since I was little, tomatoes have woven themselves into cherished
              memories of my grandfather. Together, we’d tend his tomato fields,
              harvesting ripe fruit and savoring the sweet, tangy flavor of each
              sun-warmed bite.
            </div>
            <div className="ai-content">
              I often wondered why he didn’t use any machinery to lighten his
              load, so he could rest instead of tending to the watering schedule
              around the clock. Each time I asked, he’d smile and say, “Do your
              machines know when the soil needs to rest?” which fueled my
              determination to find a solution.
            </div>
          </Row>
          <Carousel
            autoplay
            arrows
            autoplaySpeed={2000}
            className="carousel-image-full m-t-30 m-b-30"
          >
            {itemsSlide.map((item, index) => (
              <Image
                src={item.content}
                alt={"Image slide" + index}
                preview={false}
                key={item.id + index}
              />
            ))}
          </Carousel>
          <Row gutter={[30, 30]} align="middle">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="ai-content"
            >
              With a deep passion for technology and a desire to support him, I
              began self-learning programming, hoping to blend innovation with
              agriculture to address the needs he’d spoken of. From March to
              July 2024, I joined the project “Optimizing Tomato Irrigation
              through Deep-Learning-Enabled Wireless Sensor Networks with Fuzzy
              Logic.” This AI-driven irrigation system, designed to optimize
              water use based on real-time conditions, achieved an impressive
              95% accuracy. Our system processed data from wireless sensors that
              monitored soil moisture and temperature, forecasting ideal
              watering schedules to reduce waste and enhance crop yields.
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="ai-content"
            >
              <Image src={IMG10} alt="IMG10" preview={false} />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="ai-content"
            >
              What began with my grandfather’s tomato plants has blossomed into
              a journey to develop sustainable, efficient agricultural
              solutions. I now hope to bring about meaningful change in local
              agriculture, merging advanced technology with the wisdom he passed
              down to me.
            </motion.div>
          </Row>
        </motion.div>
        <br />
        <br />
        <motion.div
          className="ai-2"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Image src={IMG11} alt="Image 11" preview={false} />
          <Row gutter={[30, 30]} align="middle" className="m-x-0">
            <div className="ai-sub-title">A New Chapter in Cultivation</div>
            <div className="ai-content">
              In Vietnam, whenever there is a surplus of agricultural products,
              “rescue campaigns” for farmers become a common sight - a somber
              scene where the hard work of an entire season is reduced to a
              meager price. Once, I purchased some to show support, but upon
              tasting, I recognized the issue: the fruit was overly sour and
              uncompetitive in quality. This shortfall reflects a larger problem
              farmers, though experienced, often lack knowledge of modern
              farming techniques and still rely heavily on traditional methods,
              unsupported by technological advancements that could mitigate
              risks and elevate quality.
            </div>
            <Row gutter={[35, 35]}>
              <Col xs={24} sm={24} md={14}>
                <div className="ai-content">
                  Despite years of dedication, farmers face uncontrollable
                  risks, around 20%, due to unpredictable weather and pests.
                  This precarious reality leaves many households struggling,
                  clinging to uncertain outcomes. My aspiration is to improve
                  the success rate to a full 100%, giving farmers peace of mind
                  about their harvests. To achieve this, I am committed to
                  integrating science and technology into agricultural
                  practices.
                </div>
                <div className="ai-content">
                  After the successful project of optimization of an irrigation
                  system for tomatoes, my resolve to achieve this goal only grew
                  stronger. Under the guidance of my professors and in
                  collaboration with a research team at my university, I
                  expanded my focus to the early detection of plant diseases,
                  particularly citrus canker - a formidable threat to orchards.
                </div>
                <div className="ai-2-1">
                  <div>
                    From April 2023 to April 2024, I worked with mentors to
                    develop an AI-based monitoring system, designed to identify
                    signs of disease at an early stage, enabling farmers to
                    diagnose rapidly and improve crop health.
                  </div>
                  <div>
                    Drawing upon skills honed in previous projects, I built a
                    machine learning model in Python, leveraging TensorFlow and
                    Keras, trained on a dataset of 10,000 images to attain high
                    accuracy. Hugely supported by my mentors, we integrated the
                    AI system onto a Raspberry Pi 4 housed within a 3D-printed
                    protective case, enabling real-time monitoring of crop
                    health. The project earned a Gold Medal at AI-JAM Online
                    2023, highlighting technology’s positive impact on
                    agriculture.
                  </div>
                </div>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={10}
                className="justify-content-center d-flex"
              >
                <Image src={IMG12} alt="Image 12" preview={false} />
              </Col>
            </Row>
            <div className="ai-2-2">
              Through this journey, I am progressively shaping a vision of
              sustainable and intelligent agriculture, where technology empowers
              farmers not only to reduce risks but to cultivate products of
              exceptional quality. In this future, there would no longer be a
              need for “rescue campaigns.” Instead, our produce would be
              celebrated as a source of national pride.
            </div>
          </Row>
        </motion.div>
        <br />
        <br />
        <motion.div
          className="ai-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Image src={IMG13} alt="Image 13" preview={false} />
          <Row gutter={[30, 30]}>
            <Col
              xs={24}
              sm={24}
              md={16}
              className="justify-content-center d-flex"
            >
              <Image src={IMG14} alt="Image 14" preview={false} />
            </Col>
            <Col xs={24} sm={24} md={8}>
              <div className="ai-3-1">
                In Vietnam, the pomelo is a cherished fruit, deeply intertwined
                with tradition, especially during the Lunar New Year
                celebrations when it graces the five-fruit tray as a symbol of
                fulfillment and prosperity for the coming year. Yet, these
                long-lived trees take five to eight years to bear their first
                sweet fruits, and each harvest season stretches across seven to
                eight months, making every fruit a result of years of
                commitment.
              </div>
            </Col>
          </Row>
          <Row gutter={[30, 30]} className="m-t-30">
            <Col
              xs={24}
              sm={24}
              md={8}
              className="justify-content-center d-flex"
            >
              <Image src={IMG15} alt="Image 15" preview={false} />
            </Col>
            <Col xs={24} sm={24} md={8} className="ai-3-2">
              During my research on citrus trees, I discovered that a variety of
              pests and diseases severely impact citrus plants, including the
              pomelo. When I saw my grandparents nurturing a young pomelo
              orchard, I was inspired to apply my knowledge to help care for
              these tender trees.
            </Col>
            <Col
              xs={24}
              sm={24}
              md={8}
              className="justify-content-center d-flex"
            >
              <Image src={IMG16} alt="Image 16" preview={false} />
            </Col>
          </Row>
          <Row gutter={[30, 30]} className="m-t-30">
            <Col xs={24} sm={24} md={16}>
              <div className="ai-3-3">
                Tending to each young plant and anticipating their growth, while
                constantly aware of the looming threat of diseases like citrus
                canker, deepened my resolve, I came to realize that protecting
                crops from disease is as essential as optimizing irrigation.
              </div>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={8}
              className="justify-content-center d-flex"
            >
              <Image src={IMG17} alt="Image 16" preview={false} />
            </Col>
          </Row>
          <div className="m-t-30 ai-content">
            Motivated by this experience, me and my team develop the Citrus
            project an in-depth academic research study called: “Utilizing AI
            and Silver Nanoparticles for the Detection and Treatment Monitoring
            of Canker in Pomelo Trees.” Leveraging skills I had developed, I
            collaborated with my research team to analyze over 100 scientific
            papers, designing and refining an AI model to detect early signs of
            citrus canker in pomelo trees. We meticulously classified data,
            enhancing the model&apos;s accuracy by over 20%, and our findings
            were published in Sensors and Actuators A: Physical.
          </div>
          <Image
            src={IMG18}
            alt="Image 18"
            preview={false}
            className="m-t-30"
          />
          <div className="m-t-30 ai-content">
            By optimizing tomato irrigation and monitoring pomelo tree health,
            I’ve built a strong foundation in agricultural technology. Through
            these experiences, I have pursued sustainable solutions to help
            farmers combat pests, boost productivity, and achieve high-quality
            harvests - llaying the groundwork for a resilient, tech-enabled
            agricultural future.
          </div>
          <Image
            src={IMG19}
            alt="Image 19"
            preview={false}
            className="m-t-30"
          />
        </motion.div>
        <br />
        <br />
        <motion.div
          className="ai-4"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Row gutter={[30, 30]}>
            <Col xs={24} sm={24} md={12}>
              <Image src={IMG20} alt="Image 20" preview={false} />
              <div className="ai-content m-t-30">
                In Vietnam, pesticides have long been stigmatized as dangerous,
                often regarded as harmful to health and the environment.
                However, through my academic journey and deeper immersion in
                agriculture, I realized that pesticides are not inherently
                harmful—provided they are applied properly and in the correct
                dosages. To shift these misconceptions, I believe that
                scientific data offers the most compelling evidence, helping to
                clear the misunderstandings surrounding pesticides’ role in
                agriculture.
              </div>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Image src={IMG21} alt="Image 21" preview={false} />
            </Col>
          </Row>
          <Row gutter={[30, 30]} className="ai-4-2 m-t-30" align="middle">
            <Col xs={24} sm={24} md={24} lg={10}>
              <div className="ai-4-2-1">
                "Unveiling the Insidious: Hidden Issues in Our Food System."
              </div>

              <div
                className="m-t-30"
                style={{
                  fontSize: "16px",
                  textAlign: "justify",
                }}
              >
                With this mission in mind, I had the opportunity to present at
                TedxConcordia on the theme “Unveiling the Insidious: Hidden
                Issues in Our Food System.” In this talk, I discussed safe and
                effective pesticide use to protect crops and safeguard public
                health. This platform allowed me to share insights and research
                results, contributing to a change in perceptions about the role
                of chemicals in modern agriculture.
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={14}>
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/ofUZmnGjUoI?si=nQwmP8_a1eE5xKzq"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </Col>
          </Row>
          <div className="ai-4-3">
            <div
              style={{
                color: "#3E6D34",
                fontSize: "40px",
                lineHeight: "48px",
                margin: "20px 0",
              }}
            >
              PesViT: Deep Learning Approaches for Detecting Pesticide Misuse in
              Farms
            </div>
            <Row gutter={[30, 30]} align="middle">
              <Col
                xs={24}
                sm={24}
                md={14}
                style={{
                  display: "grid",
                  gap: "16px",
                }}
              >
                <Image src={IMG23} alt="Image 23" preview={false} />
                <Row gutter={[30, 30]}>
                  <Col xs={24} sm={24} md={12}>
                    <Image src={IMG24} alt="Image 24" preview={false} />
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    style={{
                      marginTop: "30px",
                    }}
                  >
                    <Image src={IMG25} alt="Image 25" preview={false} />
                  </Col>
                </Row>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={10}
                style={{
                  display: "grid",
                  gap: "30px",
                  fontSize: "16px",
                  lineHeight: "30px",
                  textAlign: "justify",
                }}
              >
                <div>
                  As I became more involved in agriculture over the years, my
                  perspective expanded beyond the familiar tomato fields of my
                  childhood. I came to understand that large-scale production
                  requires a fundamentally different approach, one in which soil
                  quality is paramount to healthy crops. Unfortunately, in
                  Vietnam, improper use of fertilizers and pesticides has led to
                  soil pollution and ecological imbalance in many farming
                  cooperatives.
                </div>
                <div>
                  Throughout my journey of integrating technology into
                  agriculture, I have witnessed the immense potential of AI to
                  enhance productivity while simultaneously protecting the
                  environment and public health. Building on this foundation,
                  from November 2022 to April 2023, I took part in the project
                  “PesViT: Deep Learning Approaches for Detecting Pesticide
                  Misuse in Farms” as a co-author and research associate. This
                  project aimed to detect instances of pesticide misuse and
                  promote safer farming practices. Our team collected data from
                  five agricultural regions and gathered hundreds of video
                  samples, forming a dataset of thousands of images to train the
                  AI model.
                </div>
              </Col>
              <Col
                style={{
                  fontSize: "16px",
                  lineHeight: "30px",
                  textAlign: "justify",
                }}
              >
                <div>
                  The AI model demonstrated promising results, achieving an
                  accuracy rate of over 90%. I contributed to the Results and
                  Conclusion sections of the study, which was subsequently
                  published in The Journal of Supercomputing. Every project I
                  undertake - be it optimizing tomato irrigation, tracking
                  pomelo diseases, or identifying pesticide misuse - reinforces
                  my commitment to using technology for a safer, more
                  sustainable agriculture. I am shaping a vision of a resilient
                  agricultural system where innovation promotes both
                  productivity and environmental stewardship.
                </div>
              </Col>
            </Row>
          </div>
        </motion.div>
      </Content>
    </Layout>
  );
};

export default AIPage;
